module.exports = __webpack_public_path__ + "img/shot_bigtx121302.3c45d1e2.png";